// src/analytics/analytics.js
import { getApp, getApps } from 'firebase/app';
import {
  getAnalytics,
  setAnalyticsCollectionEnabled,
  logEvent as fbLogEvent,
  isSupported,
} from 'firebase/analytics';
import { consentStatus } from './consent';
import { app as firebaseApp } from '../firebase/firebase';

let app;
let analytics; // undefined until initialized
let triedInit = false;

function ensureApp() {
  if (app) return app;
  if (typeof window === 'undefined') return null; // SSR guard
  // Reuse the already-initialized app from firebase.js; fallback to default app if present.
  app = firebaseApp || (getApps().length ? getApp() : null);
  return app;
}

async function initAnalyticsIfAllowed() {
  if (triedInit) return analytics || null;
  triedInit = true;

  if (typeof window === 'undefined') return null; // SSR guard
  if (consentStatus() !== 'granted') return null;

  ensureApp();
  if (!app) return null;

  // Analytics isn't supported in all environments (e.g., Safari ITP or SSR)
  const supported = await isSupported().catch(() => false);
  if (!supported) return null;

  analytics = getAnalytics(app);
  setAnalyticsCollectionEnabled(analytics, true);
  return analytics;
}

export async function enableAnalyticsNow() {
  // Call right after user clicks "Accept"
  analytics = await initAnalyticsIfAllowed();
  return analytics;
}

export function disableAnalyticsNow() {
  // You can't fully "unload", but you can disable collection going forward
  if (analytics) {
    try {
      setAnalyticsCollectionEnabled(analytics, false);
    } catch {}
  }
}

export async function logEventSafe(name, params = {}) {
  // No-op until consent is "granted"
  if (consentStatus() !== 'granted') return;
  const a = analytics || (await initAnalyticsIfAllowed());
  if (!a) return;
  try {
    fbLogEvent(a, name, params);
  } catch {}
}
